import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b626003"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hezi-client-menubar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1692867817630",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2316",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M875.263467 495.52477c0 11.307533-9.15859 20.466124-20.466124 20.466124l-655.325289 0c-11.307533 0-20.466124-9.15859-20.466124-20.466124 0-11.2973 9.15859-20.466124 20.466124-20.466124l655.325289 0C866.104877 475.058646 875.263467 484.22747 875.263467 495.52477z",
    "p-id": "2317",
    fill: "#565b66"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1692866443410",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6741",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M928 0H96C41.6 0 0 41.6 0 96v832c0 54.4 41.6 96 96 96h832c54.4 0 96-41.6 96-96V96c0-54.4-41.6-96-96-96z m32 928c0 19.2-12.8 32-32 32H96c-19.2 0-32-12.8-32-32V96c0-19.2 12.8-32 32-32h832c19.2 0 32 12.8 32 32v832z",
    "p-id": "6742",
    fill: "#565b66"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1692867629833",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "1567",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M974.848 85.3504 938.6496 49.1008 512 475.8016 85.3504 49.1008 49.152 85.3504 475.8016 512 49.152 938.6496 85.3504 974.848 512 548.1984 938.6496 974.848 974.848 938.6496 548.1984 512Z",
    "p-id": "1568",
    fill: "#565b66"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

import { ref } from 'vue'
import { setWin } from '@remote/utils/hezi-pc-client'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isMaxSize = ref(false)
const toggleWinSize = () => {
  setWin(isMaxSize.value ? 'winRestore' : 'winMaximize')
  isMaxSize.value = !isMaxSize.value
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("i", {
        title: "最小化",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setWin)('winMinimize')))
      }, _hoisted_3),
      _createElementVNode("i", {
        title: "最大化",
        onClick: toggleWinSize
      }, _hoisted_5),
      _createElementVNode("i", {
        title: "关闭",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setWin)('winHide')))
      }, _hoisted_7)
    ])
  ]))
}
}

})